const educationReducer = (state = {}, action) => {
    switch (action.type) {
        default:
            return state
    }
};

export default educationReducer;